import { lazy, useEffect, useState } from "react"
import Spinner from "../../components/Spinner"
import jwtDecode from "jwt-decode"

const ParentTuitionReport = lazy(() =>
  import("../ParentPortal/TutionReports/ParentTutionReports")
)
const SchoolTuitionReport = lazy(() =>
  import("../SchoolPortal/TutionReport/TutionReport")
)

export default function RootTuitionReports() {
  const [role, setRole] = useState("")

  useEffect(() => {
    setRole(jwtDecode(localStorage.getItem("token")).role)
  }, [])

  if (!role) return <Spinner type="child" />

  if (role === "School Manager") return <SchoolTuitionReport />
  if (role === "Parent") return <ParentTuitionReport />
}
